import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from 'commons-ui';

import { IPermission } from '../../../../../../models/settingsV2.model';
import useService from '../../utils/useService';
import { getFormDefaults } from './helper';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert, app } = useContext(AppContext);
	const { requestCreatePermissions } = useService();

	const data = getFormDefaults();

	const history = useHistory();

	const createPermissions = async (formData: IPermission) => {
		setShowLoader(true);
		try {
			const response = await requestCreatePermissions(app.appName, formData);
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to create permission');
			}
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while creating this permission', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('Permission created successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (formData: IPermission) => {
		createPermissions(formData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
